import type { Shop } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface ShopQuery {
  shop: Shop
}

export interface ShopVariables {
  shopId: GQL_ID
}

export const GQL_QUERY_SHOP = gql`
  query ($shopId: ID!) {
    shop(shop_id: $shopId) {
      id
      xid
      slug
      name
      status

      city_id
      
      workingHours
      tzOffset
      address
      phone


      minOrderCost
      pickup_delivery_cost
      has_pickup_delivery_enabled
      
      shopGeoPoint {
        latitude
        longitude
      }
      shopOpenTime
      shopCloseTime
      
      tg_chat_id
      vkMaxChatId

      images {
        url
        weight
      }

      slotPlans {
        id
        shop_id
        weekDay
        slotStartTime
        slotFinishTime
        ordersLimit
        positionsLimit
        slotTimeout
      }

      deliveryBoxes {
        id
        name
        number
        shop_id
        sort_order
        special_conditions
      }

      shopTags {
        id
        name
        system_name
      }

      is_serving_wholesale
      is_serving_retail

      deliveryDefaultPickupComment
    }
  }
`

export const useFetchShop = (variables?: ShopVariables) =>
  useQuery<ShopQuery, ShopVariables>(GQL_QUERY_SHOP, {
    variables,
    fetchPolicy: 'network-only',
    skip: !variables?.shopId
  })
